import FaqProvider from './Faq.provider';

export default FaqProvider;
